import React, { useMemo } from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const SLICE_COLORS = ['#4F6FC4', '#556287', '#8DB7E8', '#D97706', '#0F766E', '#B91C1C', '#7C3AED', '#0891B2'];

function normalizeDataPoint(item, index) {
	if (item && typeof item === 'object') {
		const nameRaw = item.name;
		const valueRaw = item.value;

		const name = typeof nameRaw === 'string' && nameRaw.trim() ? nameRaw : `Row ${index + 1}`;
		const value = typeof valueRaw === 'number' ? valueRaw : Number(valueRaw) || 0;
		return { name, value };
	}

	if (typeof item === 'number') {
		return { name: `Row ${index + 1}`, value: item };
	}

	return { name: `Row ${index + 1}`, value: 0 };
}

function PieChartWidget({ data }) {
	const sourceRows = useMemo(() => {
		if (Array.isArray(data)) {
			return data;
		}

		if (data && typeof data === 'object') {
			if (Array.isArray(data.rows)) {
				return data.rows;
			}
			if (Array.isArray(data.data)) {
				return data.data;
			}
		}

		return [];
	}, [data]);

	const chartData = useMemo(() => {
		const normalized = sourceRows.map((item, index) => normalizeDataPoint(item, index));
		return normalized.filter((row) => row.value > 0);
	}, [sourceRows]);

	if (!chartData.length) {
		return (
			<div className="flex h-full w-full items-center justify-center rounded-xl bg-slate-50 px-3 text-[12px] text-slate-500">
				No Rows Returned
			</div>
		);
	}

	return (
		<div style={{ height: '100%', width: '100%' }}>
			<ResponsiveContainer width="100%" height="100%">
				<PieChart>
					<Pie
						data={chartData}
						dataKey="value"
						nameKey="name"
						cx="50%"
						cy="50%"
						outerRadius="75%"
						innerRadius="42%"
						paddingAngle={2}
						stroke="rgba(255,255,255,0.9)"
						strokeWidth={1}
					>
						{chartData.map((entry, index) => (
							<Cell key={`${entry.name}-${index}`} fill={SLICE_COLORS[index % SLICE_COLORS.length]} />
						))}
					</Pie>
					<Tooltip
						wrapperStyle={{ backgroundColor: '#ffffff', borderRadius: 8, boxShadow: '0 6px 18px rgba(2,6,23,0.08)' }}
						labelStyle={{ color: '#64748b', fontSize: 12 }}
						itemStyle={{ color: '#0f172a' }}
					/>
					<Legend verticalAlign="bottom" iconType="circle" wrapperStyle={{ fontSize: 11, paddingTop: 8 }} />
				</PieChart>
			</ResponsiveContainer>
		</div>
	);
}

export default PieChartWidget;
